import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";

export default {
	namespaced: true,
	state: {
		lstVe2: [],
		ve2: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 21,
		search: "",
		hasNext: false,
		since: moment().format("YYYY-MM-DD"),
		until: moment().format("YYYY-MM-DD"),
	},
	getters: {
		getVe2Model(state){
            let ve2 =  {...state.ve2}
			ve2.ve2mes = new Date(ve2.ve2mes+" 12:00:00")
            return ve2
        }
	},
	mutations: {
		set(state, ve2){
			state.ve2 = ve2
			if (ve2)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.ve2 = null
		},
		setParamsDataTable(state, payload){
			state.lstVe2 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, ve2meta){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Goals/Goals/Find/${ve2meta}`)
			.then(response => {
				let ve2 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", ve2)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Goals/Goals/Insert", store.getters.getVe2Model )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/metas")
				store.state.ve2 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Goals/Goals/Update", store.getters.getVe2Model )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/metas")
				store.state.ve2 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Goals/Goals/Delete/${store.state.ve2.ve2meta}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/metas")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Goals/Goals/FindList")
			.then(response => {
				let lstVe2 = Utils.ValidateAxiosResponse(response.data);
				store.state.lstVe2 = lstVe2
				store.state.hasNext = lstVe2.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstVe2 = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 21, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let url = `/Goals/Goals/Search?search=${store.state.search}&limit=${limit}&page=${page}`
			if (store.state.since) {
				url+= `&since=${store.state.since}`
			}
			if (store.state.until) {
				url+= `&until=${store.state.until}`
			}
			let payload = await this._vm.$axios.get(url)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstVe2 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
	}
}